// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Js_array from "rescript/lib/es6/js_array.js";
import * as Js_string from "rescript/lib/es6/js_string.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Belt_Float from "rescript/lib/es6/belt_Float.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as Caml_exceptions from "rescript/lib/es6/caml_exceptions.js";
import * as Translation$BenfaerberBlog from "../Translation.bs.js";

function getPrettyDateFormat(format, date) {
  var months = [
    "January",
    "Febuary",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ];
  var s = Belt_Array.get(months, date.getMonth() | 0);
  var monthName = s !== undefined ? Js_string.slice(0, 3, s) : "";
  var year = date.getFullYear();
  var pad = function (v) {
    return (
            v < 10 ? "0" : ""
          ) + String(v);
  };
  var day = pad(date.getDate() | 0);
  var yearName = String(year);
  if (format === "Full") {
    return monthName + " " + day + ", " + yearName;
  } else {
    return monthName + " " + yearName;
  }
}

function getPrettyDate(date) {
  return getPrettyDateFormat("Full", date);
}

function getPrettyDatePartial(date) {
  return getPrettyDateFormat("MonthYear", date);
}

function unwrapNumberOption(op) {
  if (op !== undefined) {
    return op;
  } else {
    return 0;
  }
}

var InvalidDatestamp = /* @__PURE__ */Caml_exceptions.create("Blog-BenfaerberBlog.InvalidDatestamp");

function convertDatestamp(datestamp) {
  var unpacked = Belt_Array.map(Js_string.split("-", datestamp), (function (t) {
          return Belt_Option.getWithDefault(Belt_Float.fromString(t), 0);
        }));
  if (unpacked.length !== 3) {
    throw {
          RE_EXN_ID: InvalidDatestamp,
          _1: "Invalid Datestamp",
          Error: new Error()
        };
  }
  var year = unpacked[0];
  var month = unpacked[1];
  var day = unpacked[2];
  return new Date(year, month - 1, day);
}

function datestampToPrettyDate(datestamp) {
  return getPrettyDateFormat("Full", convertDatestamp(datestamp));
}

function getEpoch(d) {
  return convertDatestamp(d).getTime() / 1000 | 0;
}

function hasLanguage(article, lang) {
  return Js_array.includes(lang, article.languages);
}

function resolveLanguage(article, preferred) {
  if ((function (__x) {
          return Js_array.includes(preferred, __x.languages);
        })(article)) {
    return preferred;
  } else {
    return Belt_Option.getWithDefault(Belt_Array.get(article.languages, 0), "English");
  }
}

function parseLanguages(raw) {
  if (raw !== undefined) {
    return Belt_Array.map(raw, Translation$BenfaerberBlog.languageFromString);
  } else {
    return ["English"];
  }
}

function parseArticle(raw) {
  var series = raw.series;
  var rawLanguages = raw.languages;
  return {
          title: raw.title,
          description: raw.description,
          tags: raw.tags,
          date: raw.date,
          slug: raw.slug,
          series: (series == null) ? undefined : Caml_option.some(series),
          languages: parseLanguages((rawLanguages == null) ? undefined : Caml_option.some(rawLanguages))
        };
}

var version = String(Math.random());

function getArticles() {
  return fetch("/articles/articles.json?v=" + version).then(function (prim) {
                return prim.json();
              }).then(function (rawArticles) {
              return Promise.resolve(Js_array.sortInPlaceWith((function (a, b) {
                                return getEpoch(b.date) - getEpoch(a.date) | 0;
                              }), Belt_Array.map(rawArticles, parseArticle)));
            });
}

function getRecentArticles() {
  return getArticles().then(function (articles) {
              return Promise.resolve(Belt_Array.slice(articles, 0, 5));
            });
}

function getArticle(slug, lang) {
  var langCode = Translation$BenfaerberBlog.languageToString(lang);
  return fetch("/articles/" + slug + "." + langCode + ".md?v=" + version).then(function (prim) {
                return prim.text();
              }).then(function (markdown) {
              return Promise.resolve(markdown);
            });
}

var Api = {
  parseLanguages: parseLanguages,
  parseArticle: parseArticle,
  version: version,
  getArticles: getArticles,
  getRecentArticles: getRecentArticles,
  getArticle: getArticle
};

var $$Date$1;

var $$String$1;

export {
  $$Date$1 as $$Date,
  $$String$1 as $$String,
  getPrettyDateFormat ,
  getPrettyDate ,
  getPrettyDatePartial ,
  unwrapNumberOption ,
  InvalidDatestamp ,
  convertDatestamp ,
  datestampToPrettyDate ,
  getEpoch ,
  hasLanguage ,
  resolveLanguage ,
  Api ,
}
/* version Not a pure module */
